// extracted by mini-css-extract-plugin
module.exports = {"summary":"style__summary__Fr611"};